import { Col, Row, Typography } from 'antd';
import { ReactComponent as ChevronRight } from 'assets/icons/chevron-right.svg';
import { MemberInfo } from 'domain/entities/UserEntity';
import { PRIVATE_ROUTES } from 'presentation/router/CONSTANTS';
import { BsPersonCircle } from 'react-icons/bs';
import { Link } from 'react-router-dom';
import { commonHelpers } from "../../../../../utilities/helpers";

interface props {
    memberInfo?: MemberInfo;
}

export const InfomationStatus = ({ memberInfo }: props) => {
    const displayLoanLimitAmout = () => {
        if (memberInfo?.loanUnlimitFlag && memberInfo?.loanUnlimitFlag == 1) {
            return '-';
        }
        if (memberInfo?.unfinancedFlag) {
            return (
                <Link to={`${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_012_01}`}>
                    プロと相談が必要です{' '}
                    <ChevronRight width={16} height={16} fill="var(--thirdly)" />
                </Link>
            );
        } else if (!memberInfo?.loanLimitAmount) {
            return '-';
        } else {
            return commonHelpers.formatMoney(memberInfo?.loanLimitAmount) + '円';
        }
    }
    const kycResultNameOverride = (kycResultName: string | undefined) => {
        switch (kycResultName) {
            case 'ノーマル':
                return "*"
            case 'ゴールド':
                return "**"
            case 'プラチナ':
                return "***"
            case 'ブラック':
                return "xxx"
        }
        return undefined
    }

    return (
        <>
            <Row gutter={[40, 12]} className="info-element w-full">
                <Col span={4} className="avatar">
                    <BsPersonCircle size={60} />
                </Col>
                <Col span={20} className="content">
                    <Row className="w-full" gutter={[0, 12]}>
                        <Col className="flex" span={18}>
                            <Typography.Text className="title">
                                {memberInfo?.memberName}
                            </Typography.Text>
                            {memberInfo?.kycResultName && (
                                <div className="flex flex-shrink-0 justify-center items-center text-sm gap-1 py-1 px-4 w-fit h-7 rounded-xl bg-[#1f8ddd] text-white font-bold leading-[144%]">
                                    {kycResultNameOverride(memberInfo?.kycResultName)}
                                </div>
                            )}
                        </Col>

                    </Row>
                    <Row className="w-full" gutter={[0, 12]}>
                        <Col span={6} className="status-content">
                            会員種別
                        </Col>
                        <Col span={18} className="status">
                            {memberInfo?.memberTypeName ?? '未登録'}
                        </Col>
                    </Row>
                    <Row className="w-full" gutter={[0, 12]}>
                        <Col span={6} className="status-content">
                            融資限度額
                        </Col>
                        <Col span={18} className="status">

                            {displayLoanLimitAmout()}

                        </Col>
                    </Row>
                </Col>
            </Row>
        </>
    );
};
